"use strict";

exports.__esModule = true;
exports.flattenAggregates = flattenAggregates;
var isEmpty = require("ramda").isEmpty;
function getValues(aggregate) {
  var props = aggregate.props;
  if (!isEmpty(props.values)) {
    if (props.values.source === "input" && Array.isArray(props.values.data)) {
      return props.values.data.map(function (value) {
        return Object.assign({
          section: "aggregates",
          id: aggregate.name,
          groupId: aggregate.name,
          groupLabel: aggregate.label,
          sanitizedFieldName: aggregate.label
        }, value, aggregate.props.mergeProps || {});
      });
    }
    return null;
  }
  return null;
}
function flattenAggregates(aggregates) {
  // Section entities can be grouped like aggregate by day, week (or) single
  return aggregates.reduce(function (acc, item) {
    var name = item.name,
      label = item.label,
      type = item.type;
    var values = getValues(item);
    if (values) {
      acc = acc.concat(values);
    } else {
      acc = acc.concat(Object.assign({
        section: "aggregates",
        id: name,
        groupId: name,
        groupLabel: label,
        sanitizedFieldName: label,
        name: name,
        label: label,
        type: type
      }, item.props.mergeProps || {}));
    }
    return acc;
  }, []);
}